import * as React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { AmountFormat } from "components/common/formatter";
import * as api from "api/index";
import { getMattersBalances } from "services/postingsService";
import DataList from "components/MatterDetails/DataList";

import { Tile } from "components/UIComponents/Tile";
import { MatterPermissions } from "./MatterPermissions";
import { TileWrapper } from "components/UIComponents/TileWrapper.jsx";

const MattersCreditsandDefaults = (props) => {
  const matterDetails = useSelector((state) => state.mattersList);
  const [balances, setBalances] = useState({});
  const [accessibleUsers, setAccessibleUsers] = useState([]);
  const [currentMatterDetails, setcurrentMatterDetails] = useState();
  useEffect(() => {
    if (matterDetails !== null) {
      setcurrentMatterDetails(
        matterDetails?.matterViewDetails[props.reference]?.data
      );

      setAccessibleUsers(
        matterDetails?.matterViewDetails[props.reference]?.data?.matterAccess
      );
    }
  }, [matterDetails]);
  const dataGetter = async () => {
    try {
      const data = await getMattersBalances(currentMatterDetails.matterId);
      if (data !== undefined) {
        setBalances(data);
      }
    } catch (error) {}
  };
  useEffect(() => {
    if (currentMatterDetails !== undefined) {
      dataGetter();
    }
  }, [currentMatterDetails]);

  return (
    <TileWrapper>
      <div className="row g-2 d-flex">
        <div className="col-12 col-xl-6">
          <Tile
            heading="Credit Limit"
            height={"285px"}
            className="px-4 pt-2 pb-0 overflow-auto"
          >
            <div>
              <DataList
                text="WIP Credit Limit:"
                value={AmountFormat(currentMatterDetails?.wipCreditLimit)}
                width={"w-100"}
                valueClass={"ms-4"}
              />
            </div>
            <div>
              <DataList
                text="Disb Credit Limit:"
                value={AmountFormat(currentMatterDetails?.disbCreditLimit)}
                width={"w-100"}
                valueClass={"ms-4"}
                //   className={'mt-1'}
              />
            </div>
            <div>
              <DataList
                text="Bill Credit Limit:"
                value={AmountFormat(currentMatterDetails?.billCreditLimit)}
                width={"w-100"}
                valueClass={"ms-4"}
              />
            </div>
            <div>
              <DataList
                text="Default DDA Bank:"
                statusChart={true}
                valueClass={"ms-4"}
                value={currentMatterDetails?.defaultDDABank}
                width={"w-100"}
                keyStyles={{ minWidth: "230px" }}
              />
              <DataList
                text="Default Profit Cost Nominal:"
                statusChart={true}
                valueClass={"ms-4"}
                value={currentMatterDetails?.defaultProfitCost}
                width={"w-100"}
                keyStyles={{ minWidth: "230px" }}
              />
              <DataList
                text="Interest Scheme:"
                statusChart={true}
                valueClass={"ms-4"}
                value={currentMatterDetails?.interestSchemeName}
                width={"w-100"}
                keyStyles={{ minWidth: "230px" }}
              />
            </div>
          </Tile>
        </div>
        <div className="col-12 col-xl-6">
          <Tile className="pt-2 px-4 pb-0 overflow-auto" height={"285px"}>
            <MatterPermissions
              matterId={currentMatterDetails?.matterId}
              accessibleUsers={accessibleUsers}
              isView={true}
              setAccessibleUsers={setAccessibleUsers}
            />
          </Tile>
        </div>
      </div>
    </TileWrapper>
  );
};

export default MattersCreditsandDefaults;
